import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2, RefreshCw, XCircle } from 'lucide-react';
import { format, parseISO } from 'date-fns';

export const ManageReservationCard = ({ reservation, onChange, onCancel }) => {
  const [busy, setBusy] = useState(null);
  const run = async (action, fn) => {
    setBusy(action);
    try { await fn(reservation); } finally { setBusy(null); }
  };
  const r = reservation;

  return (
    <Card className="bg-white border-[#E7E5E4] transition-shadow hover:shadow-md" data-testid={`manage-reservation-${r.confirmation_code}`}>
      <CardContent className="p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <p className="font-serif text-xl text-[#1C1917]">
            Seat {r.inventory_label} · {format(parseISO(r.reservation_date.slice(0, 10)), 'EEE, MMM d, yyyy')}
          </p>
          <p className="text-sm text-[#78716C]">
            Code <span className="font-semibold text-[#9F1239]">{r.confirmation_code}</span>
            {r.room_number && <> · {r.guest_type === 'resident' ? 'Unit' : 'Room'} {r.room_number}</>}
            {' · '}{r.amount > 0 ? `$${Number(r.amount).toFixed(2)}` : 'FREE'}
            {' · '}<span className="capitalize">{r.status.replace(/_/g, ' ')}</span>
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" disabled={!!busy} onClick={() => run('change', onChange)} className="border-[#9F1239] text-[#9F1239]" data-testid={`manage-change-${r.confirmation_code}`}>
            {busy === 'change' ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
            Change
          </Button>
          <Button variant="destructive" disabled={!!busy} onClick={() => run('cancel', onCancel)} data-testid={`manage-cancel-${r.confirmation_code}`}>
            {busy === 'cancel' ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <XCircle className="w-4 h-4 mr-2" />}
            Cancel
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
